var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", { staticClass: "liveinfo-form", attrs: { "no-body": "" } }, [
        _c(
          "div",
          { staticClass: "m-2" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-start mb-1 mb-md-0",
                    attrs: { cols: "12" },
                  },
                  [
                    _c("b-form-datepicker", {
                      staticClass: "el-def",
                      attrs: { placeholder: "게시기간(Fr)" },
                      model: {
                        value: _vm.query.startDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "startDate", $$v)
                        },
                        expression: "query.startDate",
                      },
                    }),
                    _c("label", { staticClass: "ml-25 mr-50" }, [_vm._v("~")]),
                    _c("b-form-datepicker", {
                      staticClass: "el-def",
                      attrs: { placeholder: "게시기간(To)" },
                      model: {
                        value: _vm.query.endDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "endDate", $$v)
                        },
                        expression: "query.endDate",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-row",
              { staticClass: "mt-1" },
              [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-start mb-1 mb-md-0",
                    attrs: { cols: "12", md: "10" },
                  },
                  [
                    _c("v-select", {
                      staticClass: "el-def",
                      staticStyle: { width: "200px", "margin-right": "50px" },
                      attrs: {
                        options: _vm.codes.useTypeFixed,
                        placeholder: "모아보기",
                        reduce: function (option) {
                          return option.code
                        },
                      },
                    }),
                    _c("v-select", {
                      staticClass: "el-def",
                      staticStyle: { width: "200px", "margin-right": "30px" },
                      attrs: {
                        options: _vm.codes.useTypeFixed,
                        placeholder: "처방 팝업 알림",
                        reduce: function (option) {
                          return option.code
                        },
                      },
                    }),
                    _c("v-select", {
                      staticClass: "el-def",
                      staticStyle: { width: "200px" },
                      attrs: {
                        options: _vm.codes.surveyStatus,
                        placeholder: "설문 상태",
                        reduce: function (option) {
                          return option.code
                        },
                      },
                      model: {
                        value: _vm.query.surveyStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "surveyStatus", $$v)
                        },
                        expression: "query.surveyStatus",
                      },
                    }),
                    _c("b-form-input", {
                      staticClass: "el-def",
                      staticStyle: { width: "300px" },
                      attrs: { placeholder: "제목 검색" },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.refetchData()
                        },
                      },
                      model: {
                        value: _vm.query.filterStr,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "filterStr", $$v)
                        },
                        expression: "query.filterStr",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-end",
                    attrs: { cols: "12", md: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-search",
                        attrs: { variant: "primary" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.refetchData()
                          },
                        },
                      },
                      [_vm._v(" 조회 ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "div",
            { staticClass: "m-2" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { md: "6" },
                    },
                    [
                      _c("h5", { staticClass: "mb-0 ml-50" }, [
                        _vm._v(
                          " 투표지 리스트 [" +
                            _vm._s(_vm.totalRecords) +
                            "] 건 "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-end",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-search",
                          attrs: { variant: "outline-dark" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.excelDownload()
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "DownloadIcon" },
                          }),
                          _c("span", [_vm._v("다운로드")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-table", {
            ref: "refCommentSurveyTable",
            staticClass: "position-relative",
            attrs: {
              "primary-key": "id",
              items: _vm.commentSurveyList,
              fields: _vm.tableColumns,
              responsive: "",
              "sticky-header": "",
              selectable: "",
              "select-mode": "single",
            },
            on: { "row-selected": _vm.onRowSelectedSurvey },
            scopedSlots: _vm._u([
              {
                key: "cell(title)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          "text-overflow": "ellipsis",
                          "white-space": "nowrap",
                        },
                      },
                      [_vm._v(" " + _vm._s(data.value) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "cell(startDate)",
                fn: function (data) {
                  return [
                    _c("span", { staticClass: "text-nowrap" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("$dateFormatter")(data.value, "YYYY-MM-DD")
                          ) +
                          " ~ " +
                          _vm._s(
                            _vm._f("$dateFormatter")(
                              data.item.endDate,
                              "YYYY-MM-DD"
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(createDate)",
                fn: function (data) {
                  return [
                    _c("span", { staticClass: "text-nowrap" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("$dateFormatter")(data.value, "YYYY-MM-DD")
                          ) +
                          " "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(liveStatusName)",
                fn: function (data) {
                  return [
                    _c("span", { staticClass: "text-nowrap" }, [
                      _vm._v(" 참여 " + _vm._s(data.value) + " "),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "b-card",
        { staticClass: "mt-2" },
        [
          _c(
            "validation-observer",
            { ref: "formRules" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "EditIcon", size: "19" },
                      }),
                      _c("h4", { staticClass: "mb-0 ml-50" }, [
                        _vm._v(" 투표지 상세 "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-end",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.resetCommentSurveyData()
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "PlusSquareIcon" },
                          }),
                          _c("span", [_vm._v("신규 투표지 등록")]),
                        ],
                        1
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-1",
                          attrs: { variant: "primary" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.saveCommentSurvey()
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "SaveIcon" },
                          }),
                          _c("span", [_vm._v("투표지 저장")]),
                        ],
                        1
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-1",
                          attrs: { variant: "outline-secondary" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.removeCommentSurvey()
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "Trash2Icon" },
                          }),
                          _c("span", [_vm._v("투표지 삭제")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "제목", "label-for": "title" } },
                        [
                          _c("validation-provider", {
                            attrs: { name: "제목", rules: "required" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "title",
                                        state: errors.length > 0 ? false : null,
                                        maxlength: "90",
                                      },
                                      model: {
                                        value: _vm.commentSurveyData.title,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.commentSurveyData,
                                            "title",
                                            $$v
                                          )
                                        },
                                        expression: "commentSurveyData.title",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex align-items-center",
                      attrs: { cols: "12", md: "3" },
                    },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "게시여부", "label-for": "is-use" } },
                        [
                          _c("b-form-radio-group", {
                            attrs: {
                              id: "is-use",
                              options: _vm.codes.useTypeFixed,
                              "value-field": "code",
                              "text-field": "label",
                            },
                            model: {
                              value: _vm.commentSurveyData.isUse,
                              callback: function ($$v) {
                                _vm.$set(_vm.commentSurveyData, "isUse", $$v)
                              },
                              expression: "commentSurveyData.isUse",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "참여가능기간(Fr)",
                            "label-for": "start-date",
                          },
                        },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "참여가능기간(Fr)",
                              rules: {
                                required: true,
                                before: _vm.commentSurveyData.endDate,
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-datepicker", {
                                      attrs: {
                                        id: "start-date",
                                        placeholder: "참여가능기간(Fr)",
                                        state: errors.length > 0 ? false : null,
                                      },
                                      model: {
                                        value: _vm.commentSurveyData.startDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.commentSurveyData,
                                            "startDate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "commentSurveyData.startDate",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "참여가능기간(To)",
                            "label-for": "end-date",
                          },
                        },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "참여가능기간(To)",
                              rules: {
                                required: true,
                                after: _vm.commentSurveyData.startDate,
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-datepicker", {
                                      attrs: {
                                        id: "end-date",
                                        placeholder: "참여가능기간(To)",
                                        state: errors.length > 0 ? false : null,
                                      },
                                      model: {
                                        value: _vm.commentSurveyData.endDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.commentSurveyData,
                                            "endDate",
                                            $$v
                                          )
                                        },
                                        expression: "commentSurveyData.endDate",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex align-items-center",
                      attrs: { cols: "12", md: "3" },
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "참여 전 댓글 보기",
                            "label-for": "before-hide",
                          },
                        },
                        [
                          _c("b-form-radio-group", {
                            attrs: {
                              id: "before-view",
                              options: _vm.codes.beforeCommentView,
                              "value-field": "code",
                              "text-field": "label",
                            },
                            model: {
                              value: _vm.commentSurveyData.beforeView,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.commentSurveyData,
                                  "beforeView",
                                  $$v
                                )
                              },
                              expression: "commentSurveyData.beforeView",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mt-1 rounded p-1 bg-light-transparent" },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.commentSurveyData.isAnswer,
                          expression: "commentSurveyData.isAnswer",
                        },
                      ],
                      staticClass: "mb-1",
                      staticStyle: { color: "#ea5455" },
                    },
                    [_vm._v(" 참여자가 있어 문항 정보를 수정할 수 없습니다. ")]
                  ),
                  _vm._l(_vm.commentSurveyElements, function (element, index) {
                    return _c(
                      "div",
                      {
                        key: element.id,
                        ref: "element",
                        refInFor: true,
                        staticClass: "bg-light-transparent rounded",
                        attrs: { id: "element" + element.id },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "d-flex align-items-center",
                                attrs: { cols: "12", md: "3" },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "컨텐츠 유형",
                                      "label-for": "is-interest-content",
                                    },
                                  },
                                  [
                                    _c("b-form-radio-group", {
                                      attrs: {
                                        id: "is-interest-content",
                                        options: _vm.codes.useTypeFixed,
                                        disabled:
                                          _vm.commentSurveyData.isAnswer,
                                        "value-field": "code",
                                        "text-field": "label",
                                      },
                                      model: {
                                        value: element.useInterestContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            element,
                                            "useInterestContent",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "element.useInterestContent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "12", md: "2" } }, [
                              _c("h6", [_vm._v(" " + _vm._s("문항") + " ")]),
                            ]),
                            false
                              ? _c(
                                  "b-col",
                                  {
                                    staticClass: "text-right pr-2",
                                    staticStyle: { "align-content": "center" },
                                    attrs: { cols: "12", md: "10" },
                                  },
                                  [
                                    _vm.commentSurveyElements.length > 1 &&
                                    !_vm.commentSurveyData.isAnswer
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "btn-icon",
                                            staticStyle: { color: "white" },
                                            attrs: { variant: "flat-dark" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeElement(
                                                  element.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "mr-50",
                                              attrs: { icon: "Trash2Icon" },
                                            }),
                                            _c("span", [_vm._v("문항 삭제")]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12", md: "10" } },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "문항 제목",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                disabled:
                                                  _vm.commentSurveyData
                                                    .isAnswer,
                                                placeholder:
                                                  "문항을 입력하세요",
                                                maxlength: "90",
                                              },
                                              model: {
                                                value: element.title,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    element,
                                                    "title",
                                                    $$v
                                                  )
                                                },
                                                expression: "element.title",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              {
                                staticClass: "pl-0",
                                attrs: { cols: "12", md: "2" },
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      variant: "primary",
                                      disabled: _vm.commentSurveyData.isAnswer,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.addElementChoice(element.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-50",
                                      attrs: { icon: "PlusIcon" },
                                    }),
                                    _c("span", [_vm._v("선택지 추가")]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._l(
                          element.commentSurveyElementChoices,
                          function (choice, dIdx) {
                            return _c(
                              "b-row",
                              {
                                key: element.id + "-" + choice.id,
                                ref: "elementChoice",
                                refInFor: true,
                                staticClass:
                                  "m-1 p-1 bg-light-secondary rounded col-10",
                                attrs: {
                                  id:
                                    "element" +
                                    element.id +
                                    "-choice" +
                                    choice.id,
                                },
                              },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "d-flex align-items-center",
                                    attrs: { cols: "12", md: "12" },
                                  },
                                  [
                                    _c("b-avatar", {
                                      staticClass: "align-baseline",
                                      style:
                                        "margin-right: 10px; cursor: default; background-color:" +
                                        choice.colors.hex +
                                        " !important;",
                                      attrs: {
                                        variant: "primary",
                                        text: choice.seq.toString(),
                                      },
                                    }),
                                    _c(
                                      "b-input-group",
                                      {
                                        staticClass: "input-group-merge",
                                        staticStyle: {
                                          "padding-right": "14px",
                                        },
                                        attrs: { size: "sm" },
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticStyle: { height: "35px" },
                                          attrs: {
                                            disabled:
                                              _vm.commentSurveyData.isAnswer,
                                            size: "sm",
                                            placeholder: "선택지를 입력하세요",
                                            maxlength: "90",
                                          },
                                          model: {
                                            value: choice.description,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                choice,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression: "choice.description",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        style:
                                          "height: 100%; margin-right: 14px; background-color:" +
                                          choice.colors.hex +
                                          " !important;",
                                        attrs: {
                                          disabled:
                                            _vm.commentSurveyData.isAnswer,
                                          size: "sm",
                                        },
                                        on: {
                                          focus: function ($event) {
                                            return _vm.showPicker(
                                              element.id,
                                              choice.id
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.hidePicker(
                                              element.id,
                                              choice.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "DropletIcon" },
                                        }),
                                      ],
                                      1
                                    ),
                                    choice.isPickerVisible
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              position: "absolute",
                                              left: "100%",
                                              "z-index": "1000",
                                            },
                                            on: {
                                              mousedown: function ($event) {
                                                $event.preventDefault()
                                              },
                                            },
                                          },
                                          [
                                            _c("Sketch", {
                                              attrs: {
                                                "preset-colors":
                                                  _vm.colorPreset,
                                              },
                                              model: {
                                                value: choice.colors,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    choice,
                                                    "colors",
                                                    $$v
                                                  )
                                                },
                                                expression: "choice.colors",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "b-button",
                                      {
                                        staticStyle: { height: "100%" },
                                        attrs: {
                                          disabled:
                                            element.commentSurveyElementChoices
                                              .length < 3 ||
                                            _vm.commentSurveyData.isAnswer,
                                          variant: "danger",
                                          size: "sm",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeElementChoice(
                                              element.id,
                                              choice.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "Trash2Icon" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                element.useInterestContent
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "mt-1",
                                        attrs: { cols: "12", md: "12" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _c("validation-provider", {
                                              staticClass: "flex-grow-1",
                                              staticStyle: {
                                                "padding-right": "14px",
                                              },
                                              attrs: {
                                                name: "컨텐츠 유형",
                                                vid:
                                                  "interestContent-" +
                                                  element.id +
                                                  "-" +
                                                  choice.id,
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c("b-form-input", {
                                                          staticStyle: {
                                                            height: "35px",
                                                          },
                                                          attrs: {
                                                            size: "sm",
                                                            placeholder:
                                                              "컨텐츠 유형 선택",
                                                            readonly: "",
                                                            state:
                                                              errors.length > 0
                                                                ? false
                                                                : null,
                                                          },
                                                          model: {
                                                            value:
                                                              choice.interestContentTitles,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                choice,
                                                                "interestContentTitles",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "choice.interestContentTitles",
                                                          },
                                                        }),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c(
                                              "b-button",
                                              {
                                                staticStyle: { height: "35px" },
                                                attrs: {
                                                  variant: "outline-primary",
                                                  disabled:
                                                    _vm.commentSurveyData
                                                      .isAnswer,
                                                  size: "sm",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.openInterestContentSelect(
                                                      element.id,
                                                      choice.id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("feather-icon", {
                                                  staticClass: "mr-50",
                                                  attrs: { icon: "SearchIcon" },
                                                }),
                                                _c("span", [
                                                  _vm._v("유형 선택"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          }
                        ),
                      ],
                      2
                    )
                  }),
                  false
                    ? _c(
                        "div",
                        {
                          staticClass: "p-1",
                          attrs: { disabled: _vm.commentSurveyData.isAnswer },
                        },
                        [
                          _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12", md: "9" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.addElement()
                                        },
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "PlusIcon" },
                                      }),
                                      _c("span", [_vm._v("신규 문항 추가")]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("interest-content-select", {
        attrs: {
          "show-content-select": _vm.showInterestContentSelect,
          "selected-value": _vm.selectedInterestContent.interestContentIds,
        },
        on: { close: _vm.interestContentSelect.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }